export default "__VITE_ASSET__WTwU6HyV__"